module.exports = __webpack_public_path__ + "static/media/wheel.4a8ce244.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/wheel.png
// module id = 662
// module chunks = 0